import LogoTradein from '@/assets/images/tradein.png'
import { PrivateRoutes, PublicRoutes } from '@/constants/routes'
import RoleChildrenGuard from '@/guards/RoleChildrenGuard'
import { IConfigSeller } from '@/models/configSeller'
import { IUser } from '@/models/user.model'
import { useAppDispatch } from '@/store/store'
import { resetUser } from '@/store/user'
import { Avatar, Image, Dropdown, DropdownTrigger, DropdownMenu, DropdownItem, Button } from '@nextui-org/react'
import { FC, useState } from 'react'
import { MdLogout, MdMenu, MdClose } from 'react-icons/md'
import { useSelector } from 'react-redux'
import { Link, useParams, useLocation } from 'react-router-dom'

const Header: FC = () => {
  const dispatch = useAppDispatch()
  const { slug } = useParams<{ slug: string }>()
  const location = useLocation()

  const configSeller = useSelector((store: { config: IConfigSeller }) => store.config)
  const userState = useSelector((store: { user: IUser }) => store.user)
  const isSamsungPeru = configSeller.config.s3.FOLDER_APP === 'ti_samsung_pe'

  const [menuOpen, setMenuOpen] = useState(false)

  const toggleMenu = () => setMenuOpen(!menuOpen)

  const getLinkClass = (path: string) =>
    location.pathname === path
      ? 'text-black bg-[#f7f7ff] py-2 px-4 font-bold rounded-full inline-block text-sm border '
      : 'text-black text-sm py-2 px-4 border border-white hover:bg-slate-200 hover:border-slate-200 rounded-full bg-transparent'

  return (
    <header className={`p-2 bg-white shadow relative h-auto 4xl:h-[64px] ${configSeller.config.linkCA === undefined ? 'mb-0' : 'mb-6'}`}>
      <div className='flex items-center justify-between'>
        <div className='flex items-center'>
          <Image src={configSeller.config.logo} alt='Logo' className='h-[30px] rounded-none' />
          <Image src={LogoTradein} alt='Logo Tradein' className='h-[30px] ml-4 rounded-none' />
        </div>

        {/* Botón Hamburguesa (visible en mobile) */}
        <div className='4xl:hidden'>
          {menuOpen
            ? <MdClose className='text-4xl cursor-pointer' onClick={toggleMenu} />
            : <MdMenu className='text-4xl cursor-pointer' onClick={toggleMenu} />}
        </div>

        {/* Navegación para pantallas grandes */}
        <div className='hidden 4xl:flex gap-2 items-center justify-center col-span-8'>
          <RoleChildrenGuard roles={[Number(import.meta.env.VITE_PERFIL_ADMIN), Number(import.meta.env.VITE_PERFIL_JEFETIENDA), Number(import.meta.env.VITE_PERFIL_CUSTODIA), Number(import.meta.env.VITE_PERFIL_EJECUTIVO), Number(import.meta.env.VITE_PERFIL_EJECUTIVO_CAJA)]} PublicValidationFragment={null}>
            <Link to={PrivateRoutes.HOME.replace(':slug', String(slug))} className={getLinkClass(PrivateRoutes.HOME.replace(':slug', String(slug)))}>HOME</Link>
            {!isSamsungPeru &&
              <Link to={PrivateRoutes.PICKUP_FORM.replace(':slug', String(slug))} className={getLinkClass(PrivateRoutes.PICKUP_FORM.replace(':slug', String(slug)))}>FORMULARIO PICK UP</Link>}

            {configSeller.config.s3.FOLDER_APP === 'ti_macstore' &&
              <Link to={PublicRoutes.SLUG.replace(':slug', String(slug))} className={getLinkClass(PublicRoutes.SLUG.replace(':slug', String(slug)))}>COTIZAR</Link>}

            {configSeller.config.s3.FOLDER_APP === 'ti_samsung_pe' &&
              <Link to={PrivateRoutes.DATABANK.replace(':slug', String(slug))} className={getLinkClass(PrivateRoutes.DATABANK.replace(':slug', String(slug)))}>DATOS BANCARIOS</Link>}
          </RoleChildrenGuard>

          {configSeller.config.s3.FOLDER_APP === 'ti_macstore' &&
            <RoleChildrenGuard roles={[Number(import.meta.env.VITE_PERFIL_EJECUTIVO), Number(import.meta.env.VITE_PERFIL_EJECUTIVO_CAJA)]} PublicValidationFragment={null}>
              <Link to={PrivateRoutes.HOME.replace(':slug', String(slug))} className={getLinkClass(PrivateRoutes.HOME.replace(':slug', String(slug)))}>HOME</Link>
              <Link to={PublicRoutes.SLUG.replace(':slug', String(slug))} className={getLinkClass(PublicRoutes.SLUG.replace(':slug', String(slug)))}>COTIZAR</Link>
            </RoleChildrenGuard>}

          <RoleChildrenGuard roles={[Number(import.meta.env.VITE_PERFIL_EJECUTIVO), Number(import.meta.env.VITE_PERFIL_EJECUTIVO_CAJA), Number(import.meta.env.VITE_PERFIL_JEFETIENDA), Number(import.meta.env.VITE_PERFIL_ADMIN), Number(import.meta.env.VITE_PERFIL_TI_COTIZADOR)]} PublicValidationFragment={null}>
            {(configSeller.config.s3.FOLDER_APP === 'ti_samsung_pe_rom' || configSeller.config.s3.FOLDER_APP === 'ti_falabella' || configSeller.config.s3.FOLDER_APP === 'ti_falabella_pe' || configSeller.config.s3.FOLDER_APP === 'ti_motorola' || configSeller.config.s3.FOLDER_APP === 'ti_coppel' || configSeller.config.s3.FOLDER_APP === 'ti_wom' || configSeller.config.s3.FOLDER_APP === 'ti_oppo' || configSeller.config.s3.FOLDER_APP === 'ti_xiaomi' || configSeller.config.s3.FOLDER_APP === 'ti_conecta_peru' || configSeller.config.s3.FOLDER_APP === 'ti_claro' || configSeller.config.s3.FOLDER_APP === 'ti_samsung_mx') &&
              <Link to={PrivateRoutes.FORMULARIO.replace(':slug', String(slug))} className={getLinkClass(PrivateRoutes.FORMULARIO.replace(':slug', String(slug)))}>COTIZAR</Link>}
          </RoleChildrenGuard>

          {
            configSeller.config.permisos.ENABLE_CONTRIBUTION === 1
              ? (
                <RoleChildrenGuard roles={[Number(import.meta.env.VITE_PERFIL_ADMIN)]} PublicValidationFragment={null}>

                  <Dropdown>
                    <DropdownTrigger>
                      <Button as={Link} className={getLinkClass(PrivateRoutes.CONTRIBUTIONS.replace(':slug', String(slug)))}>ADMIN</Button>
                    </DropdownTrigger>
                    <DropdownMenu aria-label='Static Actions'>
                      <DropdownItem href={PrivateRoutes.CONTRIBUTIONS.replace(':slug', String(slug))} key='campaign'>INCENTIVOS</DropdownItem>
                    </DropdownMenu>
                  </Dropdown>
                </RoleChildrenGuard>
                )
              : null
          }

          <a href={configSeller.config.linkCA} target='_blank' rel='noreferrer' className='text-black text-sm py-2 px-4 border border-white hover:bg-slate-200 hover:border-slate-200  rounded-full uppercase'>Centro de ayuda</a>
        </div>

        {/* Usuario y logout */}
        <div className='hidden 4xl:flex items-center justify-end'>
          <Avatar name={userState.name[0]} className='bg-black text-white font-black text-xl' />
          <div className='mx-2'>
            <p className='font-bold mb-0'>{userState.name} ({userState.name_role.replace('TI_', '')})</p>
            <p>{userState.email}</p>
          </div>
          <MdLogout className='text-black text-4xl cursor-pointer rounded-full hover:bg-gray-300 p-2' onClick={() => dispatch(resetUser())} />
        </div>
      </div>

      {/* Menú Mobile */}
      {menuOpen && (
        <div className='4xl:hidden mt-2 space-y-2'>
          <RoleChildrenGuard roles={[Number(import.meta.env.VITE_PERFIL_ADMIN), Number(import.meta.env.VITE_PERFIL_JEFETIENDA), Number(import.meta.env.VITE_PERFIL_CUSTODIA), Number(import.meta.env.VITE_PERFIL_EJECUTIVO), Number(import.meta.env.VITE_PERFIL_EJECUTIVO_CAJA)]} PublicValidationFragment={null}>
            <Link to={PrivateRoutes.HOME.replace(':slug', String(slug))} className={getLinkClass(PrivateRoutes.HOME.replace(':slug', String(slug)))}>HOME</Link>
            {!isSamsungPeru &&
              <Link to={PrivateRoutes.PICKUP_FORM.replace(':slug', String(slug))} className={getLinkClass(PrivateRoutes.PICKUP_FORM.replace(':slug', String(slug)))}>FORMULARIO PICK UP</Link>}
            {configSeller.config.s3.FOLDER_APP === 'ti_macstore' &&
              <Link to={PublicRoutes.SLUG.replace(':slug', String(slug))} className={getLinkClass(PublicRoutes.SLUG.replace(':slug', String(slug)))}>COTIZAR</Link>}
            {configSeller.config.s3.FOLDER_APP === 'ti_samsung_pe' &&
              <Link to={PrivateRoutes.DATABANK.replace(':slug', String(slug))} className={getLinkClass(PrivateRoutes.DATABANK.replace(':slug', String(slug)))}>DATOS BANCARIOS</Link>}
          </RoleChildrenGuard>

          <RoleChildrenGuard roles={[Number(import.meta.env.VITE_PERFIL_EJECUTIVO), Number(import.meta.env.VITE_PERFIL_EJECUTIVO_CAJA), Number(import.meta.env.VITE_PERFIL_JEFETIENDA), Number(import.meta.env.VITE_PERFIL_ADMIN), Number(import.meta.env.VITE_PERFIL_TI_COTIZADOR)]} PublicValidationFragment={null}>
            {(configSeller.config.s3.FOLDER_APP === 'ti_samsung_pe_rom' || configSeller.config.s3.FOLDER_APP === 'ti_falabella' || configSeller.config.s3.FOLDER_APP === 'ti_falabella_pe' || configSeller.config.s3.FOLDER_APP === 'ti_motorola' || configSeller.config.s3.FOLDER_APP === 'ti_coppel' || configSeller.config.s3.FOLDER_APP === 'ti_wom' || configSeller.config.s3.FOLDER_APP === 'ti_oppo' || configSeller.config.s3.FOLDER_APP === 'ti_conecta_peru' || configSeller.config.s3.FOLDER_APP === 'ti_claro' || configSeller.config.s3.FOLDER_APP === 'ti_samsung_mx') &&
              <Link to={PrivateRoutes.FORMULARIO.replace(':slug', String(slug))} className={getLinkClass(PrivateRoutes.FORMULARIO.replace(':slug', String(slug)))}>COTIZAR</Link>}
          </RoleChildrenGuard>

          <a href={configSeller.config.linkCA} target='_blank' rel='noreferrer' className='block text-black text-sm py-2 px-4 border border-white hover:bg-slate-200 hover:border-slate-200 rounded-full uppercase'>Centro de ayuda</a>

          {/* Info usuario en mobile */}
          <div className='flex items-center gap-2 border-t pt-2 mt-2'>
            <Avatar name={userState.name[0]} className='bg-black text-white font-black text-xl' />
            <div>
              <p className='font-bold mb-0'>{userState.name} ({userState.name_role.replace('TI_', '')})</p>
              <p className='text-xs'>{userState.email}</p>
            </div>
            <MdLogout className='text-black text-4xl cursor-pointer rounded-full hover:bg-gray-300 p-1 ml-auto' onClick={() => dispatch(resetUser())} />
          </div>
        </div>
      )}
    </header>
  )
}

export default Header
